<form [formGroup]="domainForm">
    <div class="content-section">
        <h4 class="dialog-title" mat-dialog-title *ngIf="matData.data" i18n="@@2b97575c12ad6df028df31379af3c10d99365423"
            t="2b97575c12ad6df028df31379af3c10d99365423">Edit Email Domain</h4>
        <h4 class="dialog-title" mat-dialog-title *ngIf="!matData.data"
            i18n="@@7f6d42421bea7c9cd393ba5d67957104791d7792" t="7f6d42421bea7c9cd393ba5d67957104791d7792">New Email
            Domain</h4>
        <div class="grid">
            <div class="row">
                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@aefb77454378965c4da1a1d66000404ae9b95c3e"
                            t="aefb77454378965c4da1a1d66000404ae9b95c3e">Domain</tsl-label>
                        <input tslInput fullWidth type="text" tPlaceholder="Domain" i18n-placeholder="@@Domain"
                            placeholder="Domain" formControlName="domain" name="txtDomain" maxlength="100" />
                        <tsl-hint align="end" class="max-length-hint">{{ DomainFormControls.domain.value?.length || 0 }}
                            / 100
                        </tsl-hint>
                        <tsl-error *ngIf="
                                DomainFormControls.domain.errors &&
                                (DomainFormControls.domain.dirty || DomainFormControls.domain.touched)
                            ">
                            <span i18n="@@f04c375f9d1ab25de8b3a47b86b32bff4d29c03c"
                                t="f04c375f9d1ab25de8b3a47b86b32bff4d29c03c">
                                Domain is Required
                            </span>
                        </tsl-error>
                    </tsl-form-field>
                </div>

                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@4ba250869daa372b54d24fafc0ea934769ee4076"
                            t="4ba250869daa372b54d24fafc0ea934769ee4076">Reason</tsl-label>
                        <tsl-select tPlaceholder="Reason" i18n-placeholder="@@Reason" placeholder="Reason"
                            formControlName="reason" name="Reason" tslTooltip="" tslTooltipPosition="after">
                            <tsl-option i18n="@@9ca82952a6bc860b5391d5975322d8af8ceddfa4"
                                t="9ca82952a6bc860b5391d5975322d8af8ceddfa4">Select</tsl-option>
                            <tsl-option *ngFor="let code of reasons$ | async | sortBy: 'asc'" [value]="code">{{
                                translate.get(code) }}
                            </tsl-option>
                        </tsl-select>
                    </tsl-form-field>
                </div>

                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@9f2b9d29526a222acca62a239fbdb341c3fdca40"
                            t="9f2b9d29526a222acca62a239fbdb341c3fdca40">Website (Optional)</tsl-label>
                        <input tslInput fullWidth type="text" placeholder="Website"
                            tPlaceholder="807b2535b8c37b131279771e75076bdcef4d5ce0"
                            i18n-placeholder="@@807b2535b8c37b131279771e75076bdcef4d5ce0" formControlName="website"
                            name="txtWebsite" maxlength="500" />
                        <tsl-hint align="end" class="max-length-hint">{{ DomainFormControls.website.value?.length || 0
                            }}
                            / 500
                        </tsl-hint>
                        <tsl-error *ngIf="
                                DomainFormControls.website.errors &&
                                (DomainFormControls.website.dirty || DomainFormControls.website.touched)
                            ">
                            <span i18n="@@7e816d34409a5a0cfba0cbf490678129ce84c34e"
                                t="7e816d34409a5a0cfba0cbf490678129ce84c34e">
                                Website is Required
                            </span>
                        </tsl-error>
                    </tsl-form-field>
                </div>

                <div fxFlex="50">
                    <tsl-form-field fxFlex="90">
                        <tsl-label i18n="@@Comments" t="Comments">Comments</tsl-label>
                        <textarea tslInput fullWidth type="text" tPlaceholder="Comments" i18n-placeholder="@@Comments"
                            placeholder="Comments" formControlName="comment" name="txtComment"
                            maxlength="100"></textarea>
                        <tsl-hint align="end" class="max-length-hint">{{ DomainFormControls.comment?.value?.length || 0
                            }}
                            / 100
                        </tsl-hint>
                    </tsl-form-field>
                </div>

                <div class="grid" fxFlex="100">
                    <div class="row" *ngIf="!documents || documents.length === 0">
                        <div fxFlex="95">
                            <label class="label" i18n="@@Document" t="Document">
                                Document
                            </label>
                        </div>
                        <div fxFlex="95">
                            <tsl-file-drop [inputText]="translate.get('choose a file')" [hintText]="translate.get('Drag and Drop a File or ')" #fileDrop [accept]="getAcceptedFormat" (fileChange)="onFileAdd($event)">
                            </tsl-file-drop>
                        </div>
                    </div>
                    <div *ngIf="documents && documents.length > 0" class="row" style="padding-bottom:10px;">
                        <div class="column" fxFlex="50">
                            <tsl-label class="label" i18n="@@Document" t="Document">Document</tsl-label>
                        </div>
                    </div>
                    <div class="row" *ngIf="documents && documents.length > 0">
                        <div class="row" formArrayName="documents"
                            *ngFor="let doc of documents['controls']; let i = index">
                            <div class="row" [formGroupName]="i">
                                <div fxFlex="50">
                                    <tsl-label class="label">{{ doc.get('fileName').value }}</tsl-label>
                                    <button (click)="removeFile(i)" tsl-icon-button>
                                        <tsl-icon>delete</tsl-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div tsl-dialog-actions align="end" class="col-12">
            <button tsl-button size="small" color="black" outline (click)="onNoClick()" i18n="@@Cancel"
                t="Cancel">Cancel</button>
            <button tsl-button size="small" color="blue" filled [disabled]="domainForm.invalid" (click)="save()"
                i18n="@@Save" t="Save">Save</button>
        </div>
    </div>
</form>